"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
function _templateObject() {
    var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  max-width: var(--container-small-0);\n  margin-top: var(--gutter-large);\n\n  a {\n    display: block;\n    &:not(:last-of-type) {\n      margin-right: var(--gutter-small);\n      margin-bottom: var(--gutter-small-3);\n    }\n  }\n\n  .active {\n    cursor: not-allowed;\n    pointer-events: none;\n    color: inherit;\n  }\n"]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const gatsby_1 = require("gatsby");
var StyledPager = styled_1.default.div(_templateObject());
var Pager = function Pager(_ref) {
    var pageContext = _ref.pageContext;
    var pages = [];
    for (var i = 1; i < pageContext.numberOfPages; i++) {
        pages.push({
            number: i + 1
        });
    }
    console.log(pageContext, pageContext.pageNumber);
    return /*#__PURE__*/ react_1.default.createElement(StyledPager, null, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        activeClassName: "active",
        title: "First Page",
        to: "/writing",
        tabIndex: pageContext.pageNumber === 0 ? -1 : 0
    }, "1"), pages.map(function (p, i) {
        return /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
            activeClassName: "active",
            key: i,
            title: "Page " + p.number,
            to: "/writing/" + p.number,
            tabIndex: p.number - 1 === pageContext.pageNumber ? -1 : 0
        }, p.number);
    }));
};
exports.default = Pager;
